import { render } from "./ListePortARisque.vue?vue&type=template&id=3fbb9ac7&ts=true"
import script from "./ListePortARisque.vue?vue&type=script&lang=ts"
export * from "./ListePortARisque.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__